import React from 'react';
import Form from '../../../adminpanel/components/commonComponents/Form.v2';
import { Link } from 'react-router-dom';

const ForgotWorkspace = () => {
	const formData = {
		email: { name: 'email', label: 'Email', type: 'email' },
	};

	const form = <Form label_array={formData} />;

	return (
		<>
			<h3 className="tx-center mg-b-20">Forgot Workspace?</h3>
			<form autoComplete="off" data-parsley-validate="" data-parsley-trigger="change" noValidate="">
				{form}
				<input type="hidden" name="csrf" value="9002d9cd604829e57ca059215066cf46" id="csrf" />
				<input type="submit" name="submit" id="submit" value="Submit" className="btn btn-primary btn-block" />
			</form>
			<div className="divider-text">OR</div>
			<button className="btn btn-outline-primary btn-block">Contact Admin</button>
			<div className="mg-t-20 tx-center">
				<Link to="/login">Return to log in</Link>
			</div>
		</>
	);
};

export default ForgotWorkspace;
